import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import ActiveIcon from '../../Chat/ActiveIcon';
import { ReactComponent as QuickRepliesCross } from '../../../assets/messageStatuses/closeCross.svg';
import { ReactComponent as Dashboard } from '../../../assets/icons/dashboard/Dashboard.svg';
import { ReactComponent as DownloadIcon } from '../../../assets/icons/download/file-download.svg';
import { ExclamationCircleOutlined, MoreOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import { getDirection } from '../../../helpers';
import s from '../DashboardDrawer.module.scss';
const Header = ({ toggleDashboardDrawer, setSLAModalVisible, setDownloadDataModalVisible, }) => {
    const { t } = useTranslation();
    const direction = getDirection();
    const menu = () => {
        const items = [
            {
                key: 'setSLAHours',
                label: t('setSLAHours'),
                onClick: () => setSLAModalVisible(true),
                icon: React.createElement(Dashboard, null),
            },
            {
                key: 'downloadData',
                label: t('downloadData'),
                onClick: () => setDownloadDataModalVisible(true),
                icon: React.createElement(DownloadIcon, null),
            },
        ];
        return Object.assign({ items }, (direction === 'rtl' && { style: { direction: 'rtl' } }));
    };
    return (React.createElement("div", { className: s['dashboard__header'] },
        React.createElement("div", { className: s['dashboard__header--leftContainer'] },
            React.createElement("div", { className: s['dashboard__header--titleContainer'] },
                React.createElement("div", { className: s['title__dot'] }),
                React.createElement("div", { className: s['dashboard__header--titleText'] },
                    React.createElement("div", { className: s['dashboard__header--titleLine'], dir: direction },
                        React.createElement("div", { className: s['dashboard__header--title'] },
                            React.createElement("div", { className: s['title__live'] }, t('live'))),
                        React.createElement("div", { className: s['title__currentDate'], dir: "ltr" }, moment().format('DD/MM/YYYY, HH:mm'))),
                    React.createElement("div", { className: s['title__explanation'], dir: direction },
                        React.createElement(ExclamationCircleOutlined, { className: s['title__explanationIcon'] }),
                        t('dashboardStatsExplanation'))))),
        React.createElement("div", { className: s['dashboard__header--actionWrapper'] },
            React.createElement(Dropdown, { trigger: ['click'], placement: direction === 'rtl' ? 'bottomLeft' : 'bottomRight', overlayClassName: s['dashboard__header--dropdown'], menu: menu() },
                React.createElement(MoreOutlined, { className: s['dashboard__header--moreIcon'] })),
            React.createElement(ActiveIcon, { component: QuickRepliesCross, action: () => toggleDashboardDrawer(false) }))));
};
export default observer(Header);
